export const selectConfigState = (state) => state.configReducer || {};

export const selectConfigData = (state) =>
  selectConfigState(state).configList || {};
